export const WEBSOCKET_TIMEOUT_MS = 5000;
export const HEARTBEAT_INTERVAL_MS = 60000;//1m

export default {
    WEBSOCKET_TIMEOUT_MS,
    HEARTBEAT_INTERVAL_MS,
};